export default __webpack_public_path__ + "static/rust-development-services-6855fb0b32151f9b7f0733cfffc0c05a.jpg";